import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { qk } from '@/lib/queryKeys';
import type { PondDetailResponse } from '@/types/generated/openapi';

/**
 * The pond and its open crop (active or preparing: the detail endpoint's default
 * `selected_cycle`). Its own key under the pond's detail prefix: the pond page
 * caches the wrapped `{ data }` response under the bare prefix and the entry
 * routes cache the unwrapped one, so sharing either would read the wrong shape.
 */
export function usePondCrop(farmId: string | undefined, pondId: string) {
  return useQuery({
    queryKey: [...qk.pond.detail(farmId, pondId), 'phone'],
    queryFn: () =>
      api.get<{ data: PondDetailResponse }>(`/api/v1/farms/${farmId}/ponds/${pondId}/detail`).then((r) => r.data),
    enabled: !!farmId,
  });
}
